import * as Preact from "preact"

import App from "@fae/source/models/App.js"

let UnitSprite = function() {}
import("@fae/source/views/components/UnitSprite.jsx").then((module) => UnitSprite = module.default)
import UnitHealthBar from "@fae/source/views/components/UnitHealthBar.jsx"
import Dice from "@fae/source/data/games/ember/views/Dice.jsx"
import DiceLayout from "@fae/source/data/games/ember/views/DiceLayout.jsx"
import Navigation from "@fae/source/engine/navigating/Navigation.js"

import CarryOn from "@fae/source/data/games/ember/utility/CarryOn.js"
import * as PlotSteps from "@fae/source/data/plot/steps.js"

import "./OverworldModal.less"

// THIS IS A DUPE
function toPathKey(a, b) {
    return a.x + "x" + a.y + "to" + b.x + "x" + b.y
}

const ENCOUNTER_TYPE_LABELS = {
    "first-combat": "t1",
    "standard-combat": "t1",
    "elite-combat": "t2",
    "final-combat": "t3",
    "campfire": "Z",
    "random": "?",
    "merchant": "$",
    "treasure": "!!",
    "exit": ">",
}

export default function OverworldModal() {
    return PlotSteps.CustomViewModal({
        "view": (stage) => {
            if(App?.game == undefined) return

            const overworld = stage.overworld
            if(overworld == undefined) return

            return (
                <div class="OverworldModal">
                    <div class="Compass">
                        <div class="Subtitle">Act I</div>
                        <div class="Title">Darkwood</div>
                    </div>
                    <div class="Legend">
                        <div class="Label">
                            <div class="Value">Legend</div>
                        </div>
                        <div class="Item">
                            <div class="Key">t1</div>
                            <div class="Value">Combat</div>
                        </div>
                        <div class="Item">
                            <div class="Key">t2</div>
                            <div class="Value">Elite Combat</div>
                        </div>
                        <div class="Item">
                            <div class="Key">Z</div>
                            <div class="Value">Campfire</div>
                        </div>
                        <div class="Item">
                            <div class="Key">!!</div>
                            <div class="Value">Treasure</div>
                        </div>
                        <div class="Item">
                            <div class="Key">$</div>
                            <div class="Value">Merchant</div>
                        </div>
                        <div class="Item">
                            <div class="Key">?</div>
                            <div class="Value">Unknown</div>
                        </div>
                    </div>
                    <div class="Images">
                        {overworld.images && overworld.images.map((image) => {
                            if(image instanceof Function) image = image()
                            if(image == undefined) return
                            return (
                                <div class="Image" style={{
                                    "background-image": "url(" + (image.url || image) + ")",
                                    "background-size": image.size,
                                    "background-color": image.color,
                                    "background-position": image.position,
                                    "mix-blend-mode": image.blendmode,
                                    "opacity": image.opacity,
                                }}/>
                            )
                        })}
                    </div>
                    <div class="Overworld" style={{"width": overworld.width + "em", "height": overworld.height + "em"}}>
                        {overworld.encounters.map((encounter, index) => {
                            // const isSelectable = (overworld.player.position.x + 1 == encounter.position.x) // && (Math.abs(overworld.player.position.y - encounter.position.y) <= 1)
                            let isSelectable = (overworld.player.position.x == -1 && encounter.position.x == 0) || (overworld.paths[toPathKey(overworld.player.position, encounter.position)] != undefined)
                            return (
                                <div class="Encounter" type={encounter.type} isSelectable={isSelectable} wasSelected={encounter.wasSelected} onClick={isSelectable && onClick(stage, encounter)}
                                    style={{"left": encounter.position.x + 0.5 + "em", "top": encounter.position.y + 0.5 + "em"}}>
                                    <div class="Text">{ENCOUNTER_TYPE_LABELS[encounter.type] || "-"}</div>
                                </div>
                            )
                        })}
                        {Object.keys(overworld.paths).map((key) => {
                            const positions = key.split("to").map((position) => {
                                return {
                                    "x": parseInt(position.split("x")[0]),
                                    "y": parseInt(position.split("x")[1])
                                }
                            })
                            // const positions = [
                            //     overworld.paths[key]?.previousPosition,
                            //     overworld.paths[key]?.nextPosition,
                            // ]
                            const dy = positions[1].y - positions[0].y
                            return (
                                <div class="Path" dy={dy} style={{
                                    "top": positions[0].y + 0.5 + "em",
                                    "left": positions[0].x + 0.5 + "em",
                                }}/>
                            )
                        })}
                    </div>
                </div>
            )
        }
    })
}

function onClick(stage, encounter) {
    return function(event) {
        stage.overworld.player.position.x = encounter.position.x
        stage.overworld.player.position.y = encounter.position.y
        stage.overworld.player.encounter = encounter
        encounter.wasSelected = true

        CarryOn(stage)
    }
}
